import LineInfoCircleIcon from 'components/Luxkit/Icons/line/LineInfoCircleIcon'
import MessageBanner from 'components/Luxkit/Banners/MessageBanner'
import React from 'react'
import TextLink from 'components/Luxkit/TextLink'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'
import FormatCurrency from 'components/Common/FormatCurrency'

interface Props {
  variant: 'pastDates' | 'soldOut' | 'unavailable' | 'luxplus' | 'insurance' | undefined
  link?: string
  savings?: number
}

function CartReviewBanner(props: Props) {
  const {
    variant,
    link,
    savings,
  } = props

  switch (variant) {
    case 'pastDates':
      return (
        <MessageBanner
          kind="warning"
          description={
            <Group direction="horizontal" gap={12}>
              <BodyText variant="medium">Your selected dates are in the past</BodyText>
              <TextLink
                weight="bold"
                to={link}
                target="_blank"
              >
                Check availability
              </TextLink>
            </Group>}
        />
      )
    case 'soldOut':
      return (
        <MessageBanner
          kind="warning"
          description={
            <Group direction="horizontal" gap={12}>
              <BodyText variant="medium">Sold out for your dates</BodyText>
              <TextLink
                weight="bold"
                to={link}
                target="_blank"
              >
                Check availability
              </TextLink>
            </Group>}
          density="compact"
          icon={<LineInfoCircleIcon />}
        />
      )
    case 'unavailable':
      return (
        <MessageBanner
          kind="warning"
          description={<Group direction="horizontal" gap={12}>
            <BodyText variant="medium">Offer no longer available</BodyText>
            <TextLink
              weight="bold"
              to={link}
              target="_blank"
            >
              View similar offers
            </TextLink>
          </Group>}
          density="compact"
          icon={<LineInfoCircleIcon />}
        />
      )
    case 'luxplus':
      if (savings) {
        return (
          <MessageBanner
            kind="promotional-primary"
            description={<>Add LuxPlus+ to save an extra <FormatCurrency value={savings} format="preciseDollar" /> on this booking & unlock member-only benefits all year round</>}
            density="compact"
            icon={<LineInfoCircleIcon />}
          />
        ) } else {
        return (

          <MessageBanner
            kind="promotional-primary"
            description={
              <Group direction="horizontal" gap={12}>
                <BodyText variant="medium">
                  Save $500 on the joining fee when you book an eligible offer
                </BodyText>
                <TextLink
                  weight="bold"
                  to={link}
                >
                  Search LuxPlus+ offers
                </TextLink>
              </Group>
            }
          />
        )
      }
    case 'insurance':
      return (
        <MessageBanner
          kind="warning"
          description="Please select an eligible product from your cart to proceed with Travel Protection."
          icon={<LineInfoCircleIcon />}
        />
      )

    default:
      return null
  }
}

export default CartReviewBanner
